import { c as _c } from "react/compiler-runtime";
import { DateRangePicker, Tooltip } from '@systemeio/ui';
import ContactInfoTooltip from 'modules/contacts/components/contact-info-tooltip';
import { useFunnelSales } from 'modules/funnels/funnel/components/sales-tab/hooks/use-funnel-sales';
import { FunnelSalesFilterInterface, FunnelSalesInterface } from 'modules/funnels/funnel/components/sales-tab/types/funnel-sales-interface';
import { getSalePriceDescription } from 'modules/funnels/funnel/components/sales-tab/utils/get-sale-price-description';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import React, { useState } from 'react';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { dateTimeFormat } from 'shared/utils/date-time-format';
import { getDateRangeWithDaysDifference, getToday } from 'shared/utils/get-dates';
import { CheckCircleIcon, CloseCircleIcon } from '@systemeio/ui/icons';
interface SalesTabProps {
  funnelId: FunnelId;
}
const defaultFilters: FunnelSalesFilterInterface = {
  date: [null, null]
};
function SalesTab(t0) {
  const $ = _c(79);
  const {
    funnelId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user,
    isWsAssistant,
    intlLocale
  } = useUser();
  const {
    limit,
    setLimit,
    pagination,
    setPagination
  } = usePagination(true);
  const [filter, setFilter] = useState(defaultFilters);
  let t1;
  if ($[0] !== filter || $[1] !== funnelId || $[2] !== limit || $[3] !== pagination) {
    t1 = {
      limit,
      pagination,
      filter,
      funnelId
    };
    $[0] = filter;
    $[1] = funnelId;
    $[2] = limit;
    $[3] = pagination;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    sales
  } = useFunnelSales(t1);
  let t2;
  if ($[5] !== t) {
    t2 = t("dashboard.funnel.sales_date");
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== user?.dateFormat || $[8] !== user?.timeFormat || $[9] !== user?.timezone) {
    t3 = sale => <span>{dateTimeFormat(sale.createdAt, {
        timeFormat: user?.timeFormat,
        dateFormat: user?.dateFormat,
        timeZone: user?.timezone
      })}</span>;
    $[7] = user?.dateFormat;
    $[8] = user?.timeFormat;
    $[9] = user?.timezone;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t2 || $[12] !== t3) {
    t4 = {
      key: "createdAt",
      header: t2,
      widthPercent: 25,
      onRender: t3
    };
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t) {
    t5 = t("dashboard.funnel.sales_step");
    $[14] = t;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t5) {
    t6 = {
      key: "offer",
      header: t5,
      widthPercent: 30,
      onRender: _temp
    };
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t) {
    t7 = t("dashboard.funnel.sales_price");
    $[18] = t;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== user) {
    t8 = sale_1 => <>{getSalePriceDescription(sale_1, user)}</>;
    $[20] = user;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t7 || $[23] !== t8) {
    t9 = {
      key: "productOrderItem",
      header: t7,
      widthPercent: 35,
      onRender: t8
    };
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t) {
    t10 = t("dashboard.funnel.sales_customer");
    $[25] = t;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== isWsAssistant || $[28] !== t) {
    t11 = sale_2 => <>{!isWsAssistant ? <ContactInfoTooltip fields={sale_2.order.customer.fieldValues} referredByEmail={sale_2.order?.customer?.referredBy?.email} type={sale_2.order.customer.type} contactId={sale_2.order.customer.contact.id}><span className="w-full truncate">{sale_2.order.customer.email}</span></ContactInfoTooltip> : <span>{t("global.hidden")}</span>}</>;
    $[27] = isWsAssistant;
    $[28] = t;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t10 || $[31] !== t11) {
    t12 = {
      key: "order",
      header: t10,
      widthPercent: 30,
      onRender: t11
    };
    $[30] = t10;
    $[31] = t11;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== t) {
    t13 = t("dashboard.funnel.sales_status");
    $[33] = t;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t) {
    t14 = sale_3 => <div className="flex items-center lg:ml-4"><Tooltip label={!sale_3.cancelledAt ? t("dashboard.funnel.sales_status_received") : t("dashboard.funnel.sales_status_revoked")} mode="hover" key="status-tooltip">{sale_3.cancelledAt ? <CloseCircleIcon className={`h-[16px] w-[16px] sm:h-[20px] sm:w-[20px] ${sale_3.cancelledAt && "fill-danger"}`} /> : <CheckCircleIcon className={`h-[16px] w-[16px] sm:h-[20px] sm:w-[20px] ${!sale_3.cancelledAt && "fill-green"} `} />}</Tooltip></div>;
    $[35] = t;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== t13 || $[38] !== t14) {
    t15 = {
      key: "cancelledAt",
      header: t13,
      widthPercent: 10,
      onRender: t14
    };
    $[37] = t13;
    $[38] = t14;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== t12 || $[41] !== t15 || $[42] !== t4 || $[43] !== t6 || $[44] !== t9) {
    t16 = [t4, t6, t9, t12, t15];
    $[40] = t12;
    $[41] = t15;
    $[42] = t4;
    $[43] = t6;
    $[44] = t9;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  const columns = t16;
  let t17;
  if ($[46] !== limit || $[47] !== setLimit) {
    t17 = {
      limit,
      setLimit
    };
    $[46] = limit;
    $[47] = setLimit;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  let t18;
  if ($[49] !== pagination || $[50] !== setPagination) {
    t18 = {
      pagination,
      setPagination
    };
    $[49] = pagination;
    $[50] = setPagination;
    $[51] = t18;
  } else {
    t18 = $[51];
  }
  let t19;
  if ($[52] !== filter) {
    t19 = {
      filter,
      setFilter,
      defaultFilters
    };
    $[52] = filter;
    $[53] = t19;
  } else {
    t19 = $[53];
  }
  let t20;
  if ($[54] !== intlLocale || $[55] !== user?.createdAt || $[56] !== user?.timezone) {
    t20 = [{
      field: "date",
      onRender: (value, onChange) => <DateRangePicker key="funnel-sales-date-filter" maxDate={getToday(user?.timezone)} getDefaultDate={() => getDateRangeWithDaysDifference(57, user?.timezone)} date={value} onChange={date => onChange(date)} timezone={user?.timezone} createdAt={user?.createdAt} intlLocale={intlLocale} />
    }];
    $[54] = intlLocale;
    $[55] = user?.createdAt;
    $[56] = user?.timezone;
    $[57] = t20;
  } else {
    t20 = $[57];
  }
  let t21;
  if ($[58] !== t17 || $[59] !== t18 || $[60] !== t19 || $[61] !== t20) {
    t21 = {
      limiter: t17,
      paginator: t18,
      filterer: t19,
      filterable: t20
    };
    $[58] = t17;
    $[59] = t18;
    $[60] = t19;
    $[61] = t20;
    $[62] = t21;
  } else {
    t21 = $[62];
  }
  let t22;
  if ($[63] !== limit || $[64] !== setLimit) {
    t22 = {
      limit,
      setLimit
    };
    $[63] = limit;
    $[64] = setLimit;
    $[65] = t22;
  } else {
    t22 = $[65];
  }
  let t23;
  if ($[66] !== pagination || $[67] !== setPagination) {
    t23 = {
      pagination,
      setPagination
    };
    $[66] = pagination;
    $[67] = setPagination;
    $[68] = t23;
  } else {
    t23 = $[68];
  }
  let t24;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = {};
    $[69] = t24;
  } else {
    t24 = $[69];
  }
  let t25;
  if ($[70] !== columns || $[71] !== sales || $[72] !== t22 || $[73] !== t23) {
    t25 = <Table data={sales} columns={columns} limiter={t22} paginator={t23} actions={t24} withBorders={true} />;
    $[70] = columns;
    $[71] = sales;
    $[72] = t22;
    $[73] = t23;
    $[74] = t25;
  } else {
    t25 = $[74];
  }
  let t26;
  if ($[75] !== sales || $[76] !== t21 || $[77] !== t25) {
    t26 = <div className="mb-5 flex flex-col px-[15px] lg:px-[15px]"><ListingLayout counter={false} data={sales} title="" type="compact" filterData={t21}>{t25}</ListingLayout></div>;
    $[75] = sales;
    $[76] = t21;
    $[77] = t25;
    $[78] = t26;
  } else {
    t26 = $[78];
  }
  return t26;
}
function _temp(sale_0) {
  return <div className="truncate">{sale_0.offer.funnelStep.name}</div>;
}
export default SalesTab;